import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bisualSettingSectionKeyToTitle' })
export class BisualSettingSectionKeyToTitlePipe implements PipeTransform {
  transform(bisual_setting_key: string): string {
    switch (bisual_setting_key) {
      case 'billing':
        return 'Facturación';
      case 'rrhh':
        return 'Recursos humanos';
      case 'comercial':
        return 'Comercial';
      case 'contact':
        return 'Contacto';
      case 'technical':
        return 'Técnico';
      case 'other':
        return 'Otros';
      default:
        return '';
    }
  }
}
